export default __webpack_public_path__ + "banner-card-icon1a3ab17.png";